import z from 'zod'

export interface ErrorResponseData {
	message: string
}

export interface FileToUpload {
	id: number
	presignedUrl: string
	file: File
}

export const PaginationParamsNode = z.object({
	currentPage: z.number(),
	lastPage: z.number(),
	perPage: z.number(),
	total: z.number()
})
export type PaginationParamsNode = z.infer<typeof PaginationParamsNode>
